import VForm from "@/vuetify_custom/v-form";
import VModal from "@/vuetify_custom/v-modal_v1";
import EditAttachments from "@/views/components/file/edit_attachments_v1";
import FileUploader from "@/views/components/file/uploader.vue";
import { saveApplication } from "../../service";

export default {
  props: {
    baseInforFields: {
      type: Array,
    },
    bfileKey: {
      type: String,
    },
    spuId: {
      type: Number,
    },
  },
  data() {
    return {
      submitLoading: false,
      fields: [],
      dis: false,
      params: {},
    };
  },
  methods: {
    edit(params) {
      console.log(params);
      console.log(this.params);
      this.dis = true;
      this.params = JSON.parse(JSON.stringify(params));
    },
    submit() {
      if (
        !(
          this.$refs.base &&
          this.$refs.base.validate &&
          this.$refs.base.validate()
        )
      ) {
        return;
      }
      console.log("submit", this.params);
      saveApplication({ ...this.params, cya_spu_id: this.spuId }).then(() => {
        this.$emit("submit");
        this.dis = false;
      });
    },
  },
  render() {
    return (
      <VModal
        v-model={this.dis}
        persistent
        dynamic-height
        height-rate={0.7}
        title={"申请"}
        max-width="1000"
        loading={this.submitLoading}
        on={{
          ok: this.submit,
        }}
      >
        <VForm
          ref="base"
          v-model={this.params}
          fields={this.baseInforFields}
          scopedSlots={{
            bfiles: () => {
              return (
                <div style="display:flex">
                  <p style="width:40px">附件</p>
                  <div style="flex:1">
                    <EditAttachments
                      files={this.params.bfiles}
                      modelType={this.bfileKey}
                      modelId={this.params.id}
                    />
                    <FileUploader
                      validateFile={(file) => {
                        const a = /\.[0-9a-zA-Z]+$/.test(file.name);
                        if (!a) {
                          this.$vModal.warning({
                            title: "提示",
                            content:
                              "文件格式错误，无法解析。建议上传如下类型：.xlsx、.pdf等带有后缀的",
                          });
                        }
                        return a;
                      }}
                      on={{
                        uploaded: (bfile) => {
                          if (Array.isArray(this.params.bfiles)) {
                            this.params.bfiles.push(bfile);
                          } else {
                            this.parmas.bfiles = [bfile];
                          }
                        },
                      }}
                    />
                    <span class="color-error">
                      为保证兼容性及文档可编辑性，请上传office系列的文档(Word,
                      Excel, PPT)
                    </span>
                  </div>
                </div>
              );
            },
          }}
        ></VForm>
      </VModal>
    );
  },
};
